exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-full-stripe {\n  background-color: #3040C4;\n  color: #ffffff;\n  text-align: center;\n  height: 44px;\n  font-size: 1.2rem;\n  font-weight: 500;\n}", ""]);

// exports
